
    import { defineComponent, reactive, SetupContext, watch } from 'vue'
    import { TModal } from '@/types/webchat'

    import DialogConfirmationFinish from './page/DialogConfirmationFinish.vue'
    import DialogFinish from './page/DialogFinish.vue'
    import DialogNewAttendance from './page/DialogNewAttendance.vue'
    import DialogLoading from './page/DialogLoading.vue'

    interface SetupReturn {
        handleModal (evt: string): void

        state: TModal
    }

    export default defineComponent({
        emits: ['on-update'],

        components: {
            DialogConfirmationFinish,
            DialogFinish,
            DialogLoading,
            DialogNewAttendance
        },

        props: {
            modelValue: {
                type: Object,
                default: () => ({
                    component: '',
                    show: false,
                    bg: 'bg-white'
                })
            }
        },

        setup (props, { emit }: SetupContext): SetupReturn {
            const state = reactive<TModal>({
                component: props.modelValue.component,
                show: props.modelValue?.show,
                bg: props.modelValue?.bg ?? 'bg-white'
            })

            function handleModal (evt: string): void {
                emit('on-update', evt)
            }

            watch(() => props.modelValue.show, (val) => {
                state.show = val
            })

            watch(() => props.modelValue.component, (val) => {
                state.component = val
            })

            return {
                handleModal,
                state
            }
        }
    })
